/**
 * How many do we actually care about?
 */

export enum SubTypesEnum {
  Alias = 1,
  Category = 131,
  Collection = 298,
  CompoundDoc = 136,
  Document = 144,
  Folder = 0,
  Generation = 2,
  Project = 202,
  ProjectVol = 201,
  Release = 138,
  Revision = 139,
  ScriptNode = 32901,
  Simplate = 31678,
}

// export enum SubTypesEnum {
//   // TwoWayTee = 294,
//   Accession = 834,
//   ActiveFolder = 1298,
//   Activeview = 30309,
//   ActivityManager = 907,
//   Alias = 1,
//   Appearance = 480,
//   AppearanceFolder = 483,
//   AppearancesVolume = 481,
//   ArchiveFolder = 31711,
//   BackupManager = 290,
//   BackupProcess = 291,
//   BestBets = 274,
//   Blog = 356,
//   BlogEntry = 357,
//   BoxFolder = 530,
//   Category = 131,
//   CategoryFolder = 132,
//   Channel = 207,
//   ChannelVol = 209,
//   Classification = 199,
//   ClassificationShortcut = 197,
//   ClassificationTree = 196,
//   ClassifiedItems = 194,
//   Collection = 298,
//   Column = 902,
//   Comments = 345,
//   CommentsReply = 348,
//   CommentsVol = 346,
//   CommExpertContainer = 3030338,
//   CommExpertGroup = 3030339,
//   CommStore = 3030329,
//   CommTemplate = 3030002,
//   CommTemplateFolder = 3030333,
//   CommTemplateVol = 3030004,
//   CommURLStore = 3030335,
//   CommWorkspace = 3030334,
//   CommXSLVolume = 3030205,
//   CompoundDoc = 136,
//   CompoundEMail = 557,
//   ContentModuleFolder = 3030372,
//   CSApplicationManifest = 32658,
//   CSApplicationsVolume = 32657,
//   CustomView = 146,
//   CustomViewTemplate = 844,
//   DataFlowManager = 270,
//   DataSourceFolder = 276,
//   DirWalker = 277,
//   Discussion = 215,
//   DispositionGroup = 602,
//   Document = 144,
//   DocumentLLNode = 1297,
//   DocumentServer = 283,
//   Dossier = 32912,
//   DossierCabinet = 32916,
//   DossierCabinetArchive = 31707,
//   DossierTemplate = 32914,
//   DossierTemplateFolder = 31709,
//   DossierTemplatesVolume = 32917,
//   DossierTemplateVolume = 32915,
//   DossierVolume = 32913,
//   DPSBinding = 31602,
//   DPSFolder = 31601,
//   DPSVolume = 31603,
//   DTDLLNode = 335,
//   DynamicView = 900,
//   EMail = 749,
//   EmailConversationItems = 2504,
//   EnterpriseArchiveDocument = 753,
//   Facet = 904,
//   FacetFolder = 905,
//   FacetTree = 903,
//   FailedFolder = 1299,
//   FixedSystemColumn = 906,
//   Folder = 0,
//   Form = 223,
//   Generation = 2,
//   GENERICCONTENTMODULE = 3030371,
//   GlobalAppearance = 482,
//   HoldContainer = 833,
//   HTMLConversion = 282,
//   HTMLFormView = 226,
//   Importer = 293,
//   Inbox = 731,
//   IndexEngine = 368,
//   IndexTracer = 147,
//   IndexUpdate = 281,
//   InternalOTDS = 924,
//   ItemTemplateVol = 541,
//   ItemTemplateVolFolder = 542,
//   JournalVolume = 361,
//   LibraryExtractor = 259,
//   LibraryObj = 272,
//   LLNodeEmailFolder = 751,
//   LLNodeFAQ = 123475,
//   LLNodeFAQEntry = 123476,
//   LLNodeForum = 123469,
//   LLNodeForumEntry = 123470,
//   LLNodeURQuestion = 430,
//   LLNodeURReply = 432,
//   Locators = 422,
//   Mailbox = 732,
//   MailStore = 3030331,
//   ManagedSpace = 31710,
//   MediaType = 410,
//   MediaTypesContainer = 414,
//   MemcachedFolder = 919,
//   MemcachedProcess = 920,
//   Merge = 273,
//   MicroPost = 1281,
//   MicroPostVolume = 1282,
//   MultiVolClassification = 372,
//   MultiVolClassificationProxy = 374,
//   MultiVolClassificationTree = 373,
//   MyReservedItems = 870,
//   MyWorkbenches = 532,
//   NAVMENUVOL = 3030756,
//   News = 208,
//   OTCIndexObj = 257,
//   Partition = 371,
//   PartitionMap = 370,
//   PersonalComm = 3030203,
//   PersonalCommSystemVolume = 3030003,
//   PersonalCommVol = 3030204,
//   PersonalStagingFolder = 398,
//   PersonalWebpage = 3030343,
//   PhysicalItemBox = 424,
//   PhysicalItemContainer = 412,
//   PhysicalItemCopy = 419,
//   PhysicalItem_non_Container = 411,
//   PhysObjAdmin = 415,
//   PhysObjBatchLabels = 418,
//   PhysObjCirculation = 416,
//   PhysObjReports = 417,
//   Poll = 218,
//   Process = 271,
//   Profile = 195,
//   Project = 202,
//   ProjectTemplate = 543,
//   ProjectVol = 201,
//   Prospector = 384,
//   ProspectorQueries = 380,
//   ProspectorSnapshot = 387,
//   Provenance = 829,
//   Proxy = 260,
//   PublishingFolder = 31712,
//   PublishingFolderVolume = 31713,
//   QAFolder = 441,
//   QueryFile = 296,
//   QuestionVolume = 431,
//   RecentItems = 327,
//   RecordType = 425,
//   RecordTypesContainer = 428,
//   RedForm = 32918,
//   RedFormVolume = 32919,
//   Release = 138,
//   RemoteLLDataSource = 381,
//   Reply = 134,
//   Report = 299,
//   Revision = 139,
//   RIMSDisposition = 555,
//   RIMSDispositionsContainer = 554,
//   RIMSHoldMaintenance = 552,
//   RIMSRsiContainer = 553,
//   RMAdministration = 556,
//   RMClassification = 551,
//   RMFolder = 426,
//   RMPart = 427,
//   RMReportsContainer = 558,
//   RMThesaurus = 559,
//   ScanConfigurationVolume = 2505,
//   ScheduledHoldCriteria = 835,
//   ScriptNode = 32901,
//   SearchBroker = 258,
//   SearchEngine = 369,
//   SearchManager = 269,
//   SearchReport = 278,
//   SearchResultsTemplate = 383,
//   SearchTemplate = 292,
//   Simplate = 31678,
//   SkyPodLLVolume = 49547,
//   SliceFolder = 275,
//   SocialObject = 1280,
//   SocialObjectVolume = 1283,
//   SPCJOBDESCR = 797,
//   SPCJOBDESCRFOLDER = 796,
//   SPCVOLUME = 795,
//   spdcommittee = 3030202,
//   spdcommitteevol = 3030201,
//   spdcommitteevolume = 3030001,
//   spdemail = 3030130,
//   Spider = 280,
//   StorageManagement = 421,
//   SubmitVersionNode = 231,
//   Task = 206,
//   TaskGroup = 205,
//   TaskList = 204,
//   TaskListVol = 210,
//   TaskMilestone = 212,
//   Template = 230,
//   TemplateFolder = 268,
//   TextDocument = 145,
//   Topic = 130,
//   Transfers = 423,
//   TransportBox = 531,
//   TransportItem = 526,
//   TransportItemPart = 527,
//   UrgentRequests = 3030330,
//   URL = 140,
//   VirtualFolder = 899,
//   VolBlog = 123461,
//   VolCategories = 133,
//   VolClassification = 198,
//   VolComments = 347,
//   VolDAP = 987352,
//   VolDeletedItems = 405,
//   VolDirectory = 375,
//   VolDiscussion = 143,
//   VolDomainWorkspace = 180,
//   VolDTD = 336,
//   VolEditWorkflow = 162,
//   VolFacets = 901,
//   VolLibrary = 141,
//   VolOrphan = 403,
//   VolPersonalStaging = 397,
//   VolPerspectives = 908,
//   VolPhysObj = 413,
//   VolRecMan = 550,
//   VolRelease = 137,
//   VolReports = 211,
//   VolSystem = 148,
//   VolTracer = 149,
//   VolumeFolder = 484,
//   VolumeLLVolume = 1296,
//   VolWarehouse = 525,
//   VolWorkbin = 142,
//   VolWorkflow = 161,
//   WarehouseFolder = 529,
//   WebFormConnectionVolume = 236,
//   WebFormDatabaseConnection = 235,
//   WebFormLookup = 234,
//   WebFormLookupVolume = 233,
//   WebReports = 30303,
//   WFMapLLNode = 128,
//   WFStatusNode = 190,
//   WIKI = 5573,
//   WIKIPAGE = 5574,
//   Workbench = 528,
//   WorkflowAttachments = 154,
//   XMLActivatorCon = 286,
//   XMLActivatorProd = 285,
// }
